import { render, staticRenderFns } from "./complaintTypeList.vue?vue&type=template&id=d6d43d7a&scoped=true"
import script from "./complaintTypeList.vue?vue&type=script&lang=js"
export * from "./complaintTypeList.vue?vue&type=script&lang=js"
import style0 from "./complaintTypeList.vue?vue&type=style&index=0&id=d6d43d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d43d7a",
  null
  
)

export default component.exports